var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_411_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_411_3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_411_3",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_411_3",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEt0lEQVR4nO2dW2hcVRSGt3fFu4jX0piz1iQ1SlGKiKhURURE8MWA0pjMWhODFkrfRHxpH33tg6APtVCbmb0OiVdUsN7wwfbBCyiKKIqiWEWtd0VrHdm90NG05mTOnNlnZv4P1lPgZO/1zV575eScPc4BAAAAAAAAAMjMIzOrjkuV7jKlR73QZhOeeGXD6mOzXwF0jHpt+FxT2mnKzX+F0I7wM6S6i6Q1Yq/84QIZB8ILfdKoVS6GlG7IULrKhL45koxDK4V3p8KrIaVIGcK3m/Lvi8o4uFKU/vDKayClCBnK6014b1YZh6Tw3ya0EVI6JWLcHWNCDy1VxGH2lc2hK4OYHGydWHmyKT2TV0aLlBceW8OnQUobzM+sON8Lv9EpGS0l7J35aV4GKUugPk2XeOFPOy2jZbP/Ip2qXAYpGUiryQ1e+fuiZLSUr5/SGt0MKf+DF5oMrWrRMlqk7DGluyHlcCtDef2+FrVLMv7bFjedOwpinHPhZqAJPdxtEbZwtWwZ+LY4XTt2iik/G1uGHQzhF9OZ5PSBXCl1Hb3AhN6KLkEXSHk3nUmWu0HCa3KpF/4sevL1iOXry7ry5W4Q8FK50Qv/EDvptriUn301ucX1M6lWqib0Z+xkW3Ype0z5HtdvhJYytJaxE2ztilHa1DdtcTo+drwX3ho7qZY3hNMtU0Mnul7mSR091Qs/Hz2Z2jEpLz8xNXSG60XSycqFXunt6EnUzoZXem9OLxpyvUS9NrzSC30eO3lWmBTelU7TKtcLNJRvMqUfYyfNCg/6pSF8qyszpqy91NZa/pXyl1de68pGr7e1llsMbdqwwR3tysBz6/gEE9oWOykWO4Tm0vFlJ0WVMXvv8jO90qvRk6HlCC/8+uzMyNlRZKTTI8Mm9H7sJFjJwgt/NFdNKl2V4avDV5jwV7EnbyUNr/StryVXd0VGeDAgPCAQe9JW8vDCvzaqdFuhMsIDAQfugEafsPVMW0zrOi5i0NtaK1NbvL+t5UbsSVmPh1d+PHdbnNbGzjKl12JPxvomaOf8RHJOWzLmpJJ4oQ/iT4L7KrzSx6mOji5JRl0qV3rlr2MP3vo0vNB3jWrl2mxlSpJrvPJvsQdtfR4hxyHXiwoxpe2xB2sDE7R9cSFCT8cfKA9EeOGnFhUyNzWywpTfbOd9PgRny4Hw3vAyUmN6eMR1Gl/jcYjg/Z/4Go93PMEQwu2XIAjhUpVJCNH4EiBE4yceQjR+siFE4ycYQjR+UiEkSxKEdoQOJk+Ea0BIpz59wmnev5fCNSAEQrpPV26dCFYIhCi6rCZWCEpWE20v9pBiwabOA3i3V9BlQYiiy2pihaBkNdFlYQ8pFmzqjC6rHXC3F21vHFCyGCWrHVCyULLigJLFKFntgJKFkhUHlCxGyWqHgSlZ4TyP4v8fQtvyjtMLzRY9zsLPNslCOIqo6ImmwvfnHacpPVC4kEkmVwbCy4vFrQ7e3fbpBy2kU0PnFflVSuHoDFcWwsly4ZDhAia5K9O73BkJL+sXcc6XV34p5MCViXBikFe63gvf54UezBMmtNFrckf4wpciTts2qdy573fkHGeYa6NG1/XNufAAAAAAAAAAAAAAALjs/ANAM9OYu8hpnAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.0c6e747e2c2ed7e442f10d62e0f047f7.svg";
export { ForwardRef as ReactComponent };